import validate from "E:/www/shop_nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45trailing_45slash_45global from "E:/www/shop_nuxt/middleware/redirect-trailing-slash.global.ts";
import manifest_45route_45rule from "E:/www/shop_nuxt/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}